<template>
    <div class="login-form-wrap">
        <div class="login-form">
            <h1 class="login-title">{{ $t('entrance.login') }}</h1>

            <v-form v-model="valid">
                <kimsa-text-field
                    :label="$t('entrance.email')"
                    :placeholder="$t('entrance.email_placeholder')"
                    :rules="emailRules"
                    @change="email = $event"
                    :inputMode="'email'"
                />

                <kimsa-password-field
                    class="mt-4"
                    :label="$t('entrance.password')"
                    :placeholder="$t('entrance.password_placeholder')"
                    :rules="passwordRules"
                    @change="password = $event"
                    @enter="login"
                />

                <v-checkbox
                    v-model="rememberPassword"
                    :label="$t('common.remember_me')"
                    color="secondary"
                    hide-details
                    class="mt-1 mb-5"
                ></v-checkbox>

                <v-btn color="primary" depressed block large
                       class="black--text text-none font-weight-bold mb-4"
                       :disabled="facebookLoadingLogin"
                       :loading="loadingLogin === true || loadingUser === true"
                       @click="login">
                    {{ $t('entrance.enter') }}
                </v-btn>

                <div class="text-center">
                    <v-btn text color="txtSecondary" class="text-none forgot-link" @click="showReset">
                        {{ $t('entrance.remember_password') }}
                    </v-btn>
                </div>
                <reset-password-dialog ref="resetDialog"/>
                <deleted-account-dialog ref="deletedDialog"/>
            </v-form>
        </div>

    </div>
</template>

<script>

import KimsaTextField from "../common/inputs/KimsaTextField";
import KimsaPasswordField from "../common/inputs/KimsaPasswordField";
import ResetPasswordDialog from "@/components/entrance/ResetPasswordDialog";
import DeletedAccountDialog from "@/components/entrance/DeletedAccountDialog";

import {mapState, mapMutations, mapActions} from 'vuex'

import firebase from 'firebase/app'
import 'firebase/auth'

import {Storage} from "@/utils/Storage";
import {checkDeletedAccount} from "@/utils/DeletedAccount";

export default {
    data(vm = this) {
        return {
            ok: false,
            valid: false,
            email: '',
            password: '',
            showPassword: false,
            loadingLogin: false,
            facebookLoadingLogin: false,
            rememberPassword: false,
            emailRules: [
                v => !!v || vm.$t('rules.required'),
                v => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(v) || vm.$t('rules.invalid_email')
                }
            ],
            passwordRules: [
                v => !!v || vm.$t('rules.required'),
                v => v && v.length >= 6 || vm.$t('rules.min_length', {num: '6'})
            ],
        }
    },
    components: {
        KimsaTextField,
        KimsaPasswordField,
        ResetPasswordDialog,
        DeletedAccountDialog,
    },
    async mounted() {
        var vm = this

        const credentials = await Storage.getCredentials()
        if(credentials) {
            vm.email = credentials.email
            vm.rememberPassword = true
        }
    },
    computed: {
        ...mapState(['loadingUser']),
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        ...mapActions(['initUser']),
        login() {
            var vm = this
            if (!vm.valid) {
                return vm.showSnackBar({text: vm.$t('entrance.wrong_data'), color: 'error'})
            }

            vm.loadingLogin = true

            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
                .then(() => {
                    firebase.auth().signInWithEmailAndPassword(vm.email, vm.password)
                        .then(login => {
                            vm.loadingLogin = false
                            vm.initUser(firebase.auth().currentUser)

                            if(vm.rememberPassword) {
                                Storage.setCredentials({email: vm.email, password: vm.password})
                            } else {
                                Storage.setCredentials(null)
                            }

                        })
                        .catch(async error => {
                            vm.loadingLogin = false
                            if (error && error.code === 'auth/user-disabled') return await vm.handleDisabled()
                            vm.showSnackBar({text: vm.$t('entrance.wrong_login'), color: 'error'})
                        });
                })
                .catch(error => {
                    vm.loadingLogin = false
                    vm.showSnackBar({text: vm.$t('entrance.wrong_login'), color: 'error'})
                });
        },
        async handleDisabled() {
            const vm = this
            const info = await checkDeletedAccount(vm.email)

            if (info) return vm.$refs.deletedDialog?.show(info, 'login')

            vm.showSnackBar({text: vm.$t('entrance.account_disabled'), color: 'error'})
        },
        showReset() {
            const vm = this
            vm.$refs.resetDialog.show()
        }
    },
    watch: {
        loadingUser(val) {
            if (!val) {
                this.$emit('success')
            }
        }
    }
}
</script>

<style scoped>

.login-form-wrap {
    width: 100%;
    max-width: 380px;
}

.login-form {
    width: 100%;
}

.login-title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 24px;
}

.forgot-link {
    font-size: 14px;
    letter-spacing: normal;
    text-decoration: underline;
}

</style>
